import React from "react";
import Questions from "../questions";
import PartyButton from "../party/PartyButton";
import "../styles.css";

const PersonDetailsCard = ({ person, onPartyClick }) => {
    if (!person || !person.fornavn) return null;

    const hasNoAnswers =
        !person.answers[0].answer || person.answers[0].answer  === "Ikke besvaret";

    if (hasNoAnswers) {
        return (
            <div className="card person-card">
                <div className="person-header">
                    <h2>{person.fornavn}</h2>
                    <PartyButton party={person.parti} onClick={onPartyClick} />
                </div>

                <div className="qa-block">
                    <div className="qa-question">
                        <p>
                            <strong>{person.fornavn}</strong> har ednnu ikke besvaret vores kandidattest.
                        </p>
                        {person.url && person.url.trim() !== "" && (
                            <p>
                                Hvorfor ikke skrive og spørge hvorfor?

                                <a href={person.url} target="_blank" rel="noopener noreferrer">
                                    kontaktinfo
                                </a>
                            </p>
                        )}
                    </div>
                </div>


            </div>
        );
    }

    //TODO: Opdater med nye spsm

    const questionAnswerPairs = [
        { question: Questions.SPM1, answer: person.svar1 },
        { question: Questions.SPM2, answer: person.svar2 },
        { question: Questions.SPM3, answer: person.svar3 },
        { question: Questions.SPM4, answer: person.svar4 },
        { question: Questions.SPM5, answer: person.svar5 },
    ].filter(qa => qa.answer && qa.answer !== "");

    const questionAnswerPairs2025 = [
        { question: Questions.SPM1, answer: person.svar1 },
        { question: Questions.SPM2, answer: person.svar2 },
        { question: Questions.SPM3, answer: person.svar3 },
        { question: Questions.SPM4, answer: person.svar4 },
    ].filter(qa => qa.answer && qa.answer !== "");

    
    const questionAnswerPairs2026 = person.answers
        .map((item, index) => {
            const questionKey = `SPM${index + 1}`;

            return {
                question: Questions[questionKey],
                answer: item.answer,
                comment: item.comment
            };
        })
        .filter(qa => qa.answer && qa.answer !== "");

    return (
        <div className="card person-card">
            <div className="person-header">
                <h2>{person.fornavn}</h2>
                <PartyButton party={person.parti} onClick={onPartyClick} />
            </div>

            {questionAnswerPairs2026.map(({ question, answer, comment }, index) => (
                <div key={index} className="qa-block">
                    <div className="qa-question">{question}</div>
                    <div className="qa-answer">{answer}</div>
                    <div className="qa-answer">{comment}</div>
                </div>
            ))}
        </div>
    );
};

export default PersonDetailsCard;
